/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerApplyPackageTopUpMutationResponse,
  SubscriptionUserControllerApplyPackageTopUpPathParams,
  SubscriptionUserControllerApplyPackageTopUp401,
  SubscriptionUserControllerApplyPackageTopUp402,
} from '../../types/SubscriptionUserControllerApplyPackageTopUp.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { subscriptionUserApplyPackageTopUp } from '../../methods/subscriptionUserApplyPackageTopUp.ts';
import { useMutation } from '@tanstack/react-query';

export const subscriptionUserApplyPackageTopUpMutationKey = () =>
  [{ url: '/api/user/telegram/subscriptions/package/top-up/:productId' }] as const;

export type SubscriptionUserApplyPackageTopUpMutationKey = ReturnType<
  typeof subscriptionUserApplyPackageTopUpMutationKey
>;

/**
 * {@link /api/user/telegram/subscriptions/package/top-up/:productId}
 */
export function useSubscriptionUserApplyPackageTopUp<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubscriptionUserControllerApplyPackageTopUpMutationResponse,
      ResponseErrorConfig<
        SubscriptionUserControllerApplyPackageTopUp401 | SubscriptionUserControllerApplyPackageTopUp402
      >,
      { productId: SubscriptionUserControllerApplyPackageTopUpPathParams['productId'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? subscriptionUserApplyPackageTopUpMutationKey();

  return useMutation<
    SubscriptionUserControllerApplyPackageTopUpMutationResponse,
    ResponseErrorConfig<
      SubscriptionUserControllerApplyPackageTopUp401 | SubscriptionUserControllerApplyPackageTopUp402
    >,
    { productId: SubscriptionUserControllerApplyPackageTopUpPathParams['productId'] },
    TContext
  >(
    {
      mutationFn: async ({ productId }) => {
        return subscriptionUserApplyPackageTopUp(productId, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
